import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";

export const fetchGlobalCriteria = createAsyncThunk(
    "globalCriteria/fetchAll",
    async () => {
      const { data } = await api.get(API_ENDPOINTS.security.globalCriteria.getAll);
      return data;
    }
  );

  export const fetchGlobalCriteriaById = createAsyncThunk(
    "globalCriteria/fetchById",
    async (id) => {
      const { data } = await api.get(API_ENDPOINTS.security.globalCriteria.getById+id);
      return data;
    }
  );

  export const createGlobalCriteria = createAsyncThunk(
    "globalCriteria/create",
    async (payload) => {
      const { data } = await api.post(
        API_ENDPOINTS.security.globalCriteria.create,
        payload
      );
      return {globalCriteriaID:data?.id,...payload};
    }
  );
  
  export const updateGlobalCriteria = createAsyncThunk(
    "globalCriteria/update",
    async (payload) => {
      const { data } = await api.post(
        API_ENDPOINTS.security.globalCriteria.update,
        payload
      );
      return payload;
    } 
  );

  export const deleteGlobalCriteria = createAsyncThunk(
    "globalCriteria/delete",
    async (id) => {
      await api.delete(
        API_ENDPOINTS.security.globalCriteria.deleteGlobalCriteria + id
      );
      return id;
    }
  );